const routes = [
    {
        path: "/coop/ads",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true
        }
    },
    {
        path: "/coop/ads/:id/applications",
        component: () => import("../pages/Applications"),
        meta: {
            isAuthenticated: true
        }
    }
];

export default routes;
